"use client";
import React from "react";
import { Divider } from "@heroui/divider";
import Link from "next/link";
import { Icon } from "@iconify/react";

import { FindTalent, ApplyForJob } from "@/components";

const Footer = () => {
  return (
    <footer className=" bg-primary-1000 dark:bg-default-50  ">
      <div
        className=" lg:px-28 px-6 pt-14 pb-28 text-white text-sm max-w-screen-2xl mx-auto "
      // data-aos="fade-up"
      // data-aos-duration="3000"
      >
        <div className="flex justify-between lg:flex-nowrap flex-wrap lg:gap-0 gap-10 ">
          <div className=" space-y-3">
            <div className="font-semibold text-xl">Overview</div>
            <ul className="space-y-3">
              <li className="transition-all duration-300 ease-in-out hover:text-slate-400 cursor-pointer">
                <Link href="/about-us">About Us</Link>
              </li>
              <li className="transition-all duration-300 ease-in-out hover:text-slate-400 cursor-pointer">
                <Link href="/#faq">FAQ</Link>
              </li>
            </ul>
          </div>
          <div className=" space-y-3">
            <div className="font-semibold text-xl">Companies</div>
            <ul className="space-y-3">
              <li className="transition-all duration-300 ease-in-out hover:text-slate-400 cursor-pointer">
                <Link href="https://usecotton.io" target="_blank">
                  Cotton Group
                </Link>
              </li>
              <li className="transition-all duration-300 ease-in-out hover:text-slate-400 cursor-pointer">
                <Link href="https://service.usecotton.io" target="_blank">
                  Cotton Services{" "}
                </Link>
              </li>
              <li className="transition-all duration-300 ease-in-out hover:text-slate-400 cursor-pointer">
                <Link href="https://recruiting.usecotton.io" target="_blank">
                  Cotton Recruiting{" "}
                </Link>
              </li>
              <li className="transition-all duration-300 ease-in-out hover:text-slate-400 cursor-pointer">
                <Link href="https://security.usecotton.io" target="_blank">
                  Cotton Security
                </Link>
              </li>
            </ul>
          </div>
          <div className=" space-y-3">
            <div className="font-semibold text-xl">Legals</div>
            <ul className="space-y-3">
              <li className="transition-all duration-300 ease-in-out hover:text-slate-400">
                <Link href="/terms"> Terms and conditions </Link>
              </li>
              <li className="transition-all duration-300 ease-in-out hover:text-slate-400 cursor-pointer">
                <Link href="/cookies">Cookie policy</Link>
              </li>
              <li className="transition-all duration-300 ease-in-out hover:text-slate-400">
                <Link href="/privacy">Privacy policy</Link>
              </li>
            </ul>
          </div>
          <div>
            <div className="font-semibold text-xl mb-5">Support</div>
            <Link
              className="transition-all duration-300 ease-in-out hover:text-slate-400"
              href="mailto:support@usecotton.io"
            >
              support@usecotton.io
            </Link>
            <div className="flex items-center gap-10 text-xl mt-5">
              <Link
                className="transition-all duration-300 ease-in-out text-white hover:text-slate-400 hover:text-xl"
                href="https://x.com/appcotton78309?s=11"
                target="_blank"
              >
                <Icon className="" icon="pajamas:twitter" />
              </Link>
              <Link
                className="transition-all duration-300 ease-in-out text-white hover:text-slate-400 hover:text-xl"
                href="https://www.linkedin.com/company/usecotton/"
                target="_blank"
              >
                <Icon icon="devicon:linkedin" />
              </Link>
              <Link
                className="transition-all duration-300 ease-in-out text-white hover:text-slate-400 hover:text-xl"
                href="https://www.instagram.com/cottonapp?igsh=a2oxbHZvbzJmeXly&utm_source=qr"
                target="_blank"
              >
                <Icon icon="skill-icons:instagram" />
              </Link>
              <Link
                className="transition-all duration-300 ease-in-out text-white hover:text-slate-400 hover:text-xl"
                href="https://www.facebook.com/share/p/19SJGW7E5y/?mibextid=WC7FNe"
                target="_blank"
              >
                <Icon icon="bi:facebook" />
              </Link>
            </div>
          </div>
        </div>
        <Divider className=" my-16 bg-white" />
        <div className="flex justify-between items-center text-lg lg:flex-nowrap flex-wrap lg:gap-0 gap-8">
          <div>
            <div>&copy; {new Date().getFullYear()} - Cotton</div>
            <div className=" italic">Built by Whiteboard Labs</div>
          </div>
          <div>S.95, Tafawa Balewa Square, Race Course, Onikan, Lagos.</div>
          <div className="flex md:flex-row flex-col items-center gap-6 md:w-auto w-full">
            <FindTalent />
            <ApplyForJob />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
